export default function ConfigError() {
  return (
    <div className="min-h-screen bg-gradient-dark text-sky-300/90 flex items-center justify-center p-8">
      <div className="max-w-lg glass-card rounded-2xl p-8 text-center">
        <h1 className="text-xl font-orbitron text-sky-100 tracking-wider mb-4">
          Configuration required
        </h1>
        <p className="text-sm text-sky-300/80 mb-4">
          Supabase environment variables are not set. The app cannot authenticate
          without them.
        </p>
        <p className="text-xs text-sky-300/60 font-mono text-left bg-black/30 rounded-lg p-4 mb-4">
          REACT_APP_SUPABASE_URL
          <br />
          REACT_APP_SUPABASE_ANON_KEY
        </p>
        <p className="text-sm text-sky-300/70">
          For local development, add these to{' '}
          <code className="text-sky-200">.env.local</code>. For production,
          set them in your hosting provider&apos;s environment variables and
          rebuild (Create React App embeds env vars at build time).
        </p>
      </div>
    </div>
  );
}
